import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/uptime/mute/clearMute/uptime.clearMute.mutation.gql"
import type {
  UptimeClearMuteMutation,
  UptimeClearMuteMutationVariables,
} from "@/v2-backoffice-client/uptime/mute/clearMute/__types__/uptime.clearMute.mutation"

type Options = MutationHookOptions<
  UptimeClearMuteMutation,
  UptimeClearMuteMutationVariables
>

// useUptimeClearMuteMutation removes a target's mute. Returns the
// refreshed UptimeTarget so Apollo's normalised cache flips the
// badges atomically across every visible board.
export function useUptimeClearMuteMutation(options?: Options) {
  return useMutation<UptimeClearMuteMutation, UptimeClearMuteMutationVariables>(
    mutation,
    options,
  )
}
